// extracted by mini-css-extract-plugin
export default {"previewFrame":"AdPreviewFrame_previewFrame__8OYhh"};